import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './new-footer.component.html',
  styleUrls: ['./new-footer.component.scss']
})
export class NewFooterComponent implements OnInit{
  @Output() changeCourse = new EventEmitter<string>()
  @Output() changeNav = new EventEmitter<string>()

    @Output() change1 = new EventEmitter<string>()
  
  
  @Input('pageType') pageType:any;
  
    @Input('hideBarFlag') hideBarFlag!: boolean;
  
    @Output() change = new EventEmitter<string>()
  menuItemsList: any = {
    'cat': {
      courses: [
        { name: 'CAT Full Course + IIM ABC', link: '/details/cat-2025-full-course-iim-abc-practice-batch', linktext: 'cat-2025-full-course-iim-abc-practice-batch', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-full-course.webp' },
        { name: 'CAT 2025 Full Course', link: '/details/cat-full-course', linktext: 'cat-full-course', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-full-course-pro.webp' },
        { name: 'CAT 2025 Full Course Pro', link: '/details/CAT-2025-full-course-pro', linktext: 'CAT-2025-full-course-pro', img: 'https://media.iquanta.in/ui_images/menu-icons/mba-course.webp' },
        { name: 'Maha MBA 2025 Course', link: '/details/maha-mba-2025-course', linktext: 'maha-mba-2025-course', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-full-course-iim-abc.webp' },
        { name: 'CAT 2025 Full Course and Books', link: '/details/cat-2025-full-course-and-books', linktext: 'cat-2025-full-course-and-books', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-full-course-cat-books.webp' },
        // { name: 'CAT 2025 Full Course', link: '/details/cat-full-course', linktext: 'cat-full-course', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-full-course.webp' },
      ],
      practice: [
        { name: 'CAT Crash Course', link: '/cat-crash-course', linktext: '', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-syllabus-strategy-pdf.webp' },
        { name: 'CAT Books by iQuanta', link: '/best-cat-books', linktext: '', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-quant-formula-book-pdf.webp' },
        { name: 'iCAT Mocks - 35 Full & 45 Sectionals', link: '/details/icat-mock-test-series', linktext: 'icat-mock-test-series', img: 'https://media.iquanta.in/ui_images/menu-icons/pi-transcript-pdf.webp' },
        { name: 'IIM ABC Practice Batch 2025', link: '/details/iim-abc-practice-batch', linktext: 'iim-abc-practice-batch', img: 'https://media.iquanta.in/ui_images/menu-icons/pi-transcript-pdf.webp' },
      ],
      importantLinks: [
        // { name: 'CAT 2024 Roadmap', link: '/cat-2025', linktext: 'cat-2024', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-roadmap.webp' },
        { name: 'CAT 2025 Early Start Plan', link: '/cat-2025', linktext: 'cat-2025', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-early-start-plan.webp' },
        { name: 'CAT Past Papers as Mocks', link: '/cat-mock-test', linktext: 'cat-mock-test', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-past-papers-mock.webp' },
        { name: 'Free CAT Study material', link: '/test/free-cat-study-material', linktext: '', img: 'https://media.iquanta.in/ui_images/menu-icons/free-cat-study-material.webp' },
      ]
    },

    'mba': {
      courses: [
        { name: 'All Non CAT Course', link: '/details/all-non-cat-course-2025', linktext: 'all-non-cat-course-2025', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'NMAT-SNAP Course', link: '/details/nmat-snap-course', linktext: 'nmat-snap-course', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
        { name: 'XAT Course', link: '/xat-coaching', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-red.svg' },
        { name: 'CAT + NMAT + SNAP Course', link: '/details/cat-nmat-snap-full-course', linktext: 'cat-nmat-snap-full-course', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'MICAT Course', link: '/details/micat-course-2025', linktext: 'micat-course-2025', img: 'https://media.iquanta.in/ui_images/new-home/caticon1.png' },
        { name: 'Maha MBA 2025 Course', link: '/details/all-non-cat-course-2025', linktext: 'all-non-cat-course-2025', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
      ],
      practice: [
        { name: 'NMAT Mocks 2025', link: '/details/nmat-mock-series', linktext: 'nmat-mock-series', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-syllabus-strategy-pdf.webp' },
        { name: 'SNAP Mocks 2025', link: '/details/snap-mock-series', linktext: 'snap-mock-series', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-quant-formula-book-pdf.webp' },
        { name: 'XAT Mocks 2025', link: '/details/xat-mocks', linktext: 'xat-mocks', img: 'https://media.iquanta.in/ui_images/menu-icons/pi-transcript-pdf.webp' },
        { name: 'Non CAT Mocks', link: '/mba', linktext: '', img: 'https://media.iquanta.in/ui_images/menu-icons/pi-transcript-pdf.webp' },
      ],
      importantLinks: [
        { name: 'NMAT Roadmap', link: '/nmat-online-coaching', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
        { name: 'SNAP Roadmap', link: '/snap-online-coaching', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'XAT Roadmap', link: '/xat-coaching', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
      ]
    },

    'ipmat': {
      courses: [
        { name: 'IPMAT 2025 Full Course', link: '/details/ipmat-2025-course', linktext: 'ipmat-2025-course', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'IPMAT 2026 Full Course', link: '/details/ipmat-2026-course', linktext: 'ipmat-2026-course', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
        { name: 'IPMAT 2025 Full Course + Books', link: '/details/ipmat-course-and-ipmat-books', linktext: 'ipmat-course-and-ipmat-books', img: 'https://media.iquanta.in/ui_images/new-home/college-red.svg' },
        { name: 'IPMAT 2026 Full Course + Books', link: '/details/ipmat-2026-course-and-ipmat-books', linktext: 'ipmat-2026-course-and-ipmat-books', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'CUET + IPMAT 2025 Full Course', link: '/details/cuet-ipmat-full-course', linktext: 'cuet-ipmat-full-course', img: 'https://media.iquanta.in/ui_images/new-home/caticon1.png' },
      ],
      practice: [
        { name: 'IPMAT Mocks', link: '/ipmat-mock-test', linktext: '', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-syllabus-strategy-pdf.webp' },
        { name: 'IPMAT Books by iQuanta', link: '/best-ipmat-books', linktext: '', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-quant-formula-book-pdf.webp' },
        { name: 'IPMAT Free All-India Mock', link: '/ipmat-mock-test', linktext: '', img: 'https://media.iquanta.in/ui_images/menu-icons/pi-transcript-pdf.webp' },
        { name: 'IPMAT Free Playlist', link: 'https://www.youtube.com/channel/UC2HLd5tgt2qrlzQsRgoIUAg', linktext: '', img: 'https://media.iquanta.in/ui_images/menu-icons/pi-transcript-pdf.webp' },
      ],
      importantLinks: [
        { name: 'IPMAT 2025 Roadmap', link: '/ipmat', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
        { name: 'IPMAT Eligibility', link: 'https://www.iquanta.in/blog/ipmat-exam/', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'IPMAT Cut-off', link: 'https://www.iquanta.in/blog/ipmat-cutoff/', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
      ]
    },

    'cuet': {
      courses: [
        { name: 'CUET UG Course', link: '/details/cuet-ug-recorded-course', linktext: 'cuet-ug-recorded-course', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'Boards + CUET 2025 Commerce', link: '/details/cuet-commerce-2025', linktext: 'cuet-commerce-2025', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
        { name: 'Boards + CUET 2025 Humanities', link: '/details/cuet-2025-humanities', linktext: 'cuet-2025-humanities', img: 'https://media.iquanta.in/ui_images/new-home/college-red.svg' },
        { name: 'CUET + IPMAT 2025 Full Course', link: '/details/cuet-ipmat-full-course', linktext: 'cuet-ipmat-full-course', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'Boards + CUET 2026 Commerce', link: '/cuet', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/caticon1.png' },
      ],
      practice: [
        { name: 'CUET UG Mocks', link: '/cuet-mock-test', linktext: '', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-syllabus-strategy-pdf.webp' },
        { name: 'CUET 2025 General Test', link: 'https://www.iquanta.in/blog/cuet-general-test/', linktext: '', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-quant-formula-book-pdf.webp' },
        { name: 'CUET College Admission Mentorship', link: 'https://media.iquanta.in/ui_images/PI+Transcript.pdf', linktext: '', img: 'https://media.iquanta.in/ui_images/menu-icons/pi-transcript-pdf.webp' },
      ],
      importantLinks: [
        { name: 'CUET 2025 Roadmap', link: '/cuet', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
        { name: 'CUET Commerce Syllabus', link: 'https://www.iquanta.in/blog/cuet-commerce-colleges/', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'CUET Humanities Syllabus', link: 'https://www.iquanta.in/blog/cuet-for-arts/', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
        { name: 'CUET Subject Completion', link: 'https://www.iquanta.in/blog/cuet-for-commerce/', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
        // { name: 'CUET UG Updates', link: 'https://www.instagram.com/cuet_updates/', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
      ]
    },

    'clat': {
      courses: [
        { name: 'CLAT UG 2026 Crash Course', link: '/details/clat-crash-course', linktext: 'clat-crash-course', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'CLAT UG 2026 Full Course', link: '/details/clat-ug-2026-full-course', linktext: 'clat-ug-2026-full-course', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
      ],
      practice: [
        { name: 'CLAT UG 2026 Mocks', link: '/details/clat-test-series', linktext: 'clat-test-series', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-syllabus-strategy-pdf.webp' },
        { name: 'CLAT Books by iQuanta', link: '/details/iquanta-clat-books', linktext: 'iquanta-clat-books', img: 'https://media.iquanta.in/ui_images/menu-icons/cat-quant-formula-book-pdf.webp' },
        { name: 'CLAT Legal Mixed Practice Bank', link: '/details/CLAT-Legal-Reasoning-Practice-Material', linktext: 'CLAT-Legal-Reasoning-Practice-Material', img: 'https://media.iquanta.in/ui_images/menu-icons/pi-transcript-pdf.webp' },
      ],
      importantLinks: [
        { name: 'CLAT Roadmap', link: '/clat-coaching', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
        { name: 'Free CLAT Mocks', link: '/clat-mock-test', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'CLAT Top Colleges', link: 'https://www.iquanta.in/blog/top-clat-colleges-in-india/', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
      ]
    },

    'iit':{
      courses: [
        { name: 'IIT JEE full course', link: '/details/iit-jee-full-course-2026', linktext: 'iit-jee-full-course-2026', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'BITSAT crash course', link: '/bitsat-crash-course', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
        { name: 'JEE crash course', link: '/jee-crash-course', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
      
      ],
      practice: [
       ],
      importantLinks: [
        { name: 'IIT 2026 Roadmap', link: '/iit-jee-coaching', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
        { name: 'JEE study material', link: '/jee-study-material', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/job-experiences-icon.png' },
        { name: 'JEE Main Mock Test', link: '/jee-mock-test', linktext: '', img: 'https://media.iquanta.in/ui_images/new-home/college-insider-icon.svg' },
      ]
    }

  }

  constructor(public router: Router){

  }

  notificationList:any[]=[]
  gotoBlog(val: any) {
    window.open(val, '_blank')
  }

  gotoProduct(val: any) {
    if (val) {
      this.changeCourse.emit(val)
    }
  }

  ngOnInit(): void {
    
  }

  gotoLink(val:any){

  }

  download2(){
    
  }

  gotoFooter(val:any){

  }

  scrollTo1(val: any) {
    // this.courseService.saveScroll(val)
    // this.router.navigate(['/mba'])

  }

  qa(val: any) {
    this.change.emit(val)
    // this.router.navigate(['/test/' + val])
  }

  megMenuJs() {

    const menu: any = document.querySelector(".menu");
    const menuMain = menu.querySelector(".menu-main");
    const goBack = menu.querySelector(".go-back");
    const menuTrigger: any = document.querySelector(".mobile-menu-trigger");
    const closeMenu = menu.querySelector(".mobile-menu-close");
    let subMenu: any;
    menuMain.addEventListener("click", (e:any) => {
      if (!menu.classList.contains("active")) {
        return;
      }
      if (e.target.closest(".menu-item-has-children")) {
        const hasChildren = e.target.closest(".menu-item-has-children");
        showSubMenu(hasChildren);
      }
    });
    goBack.addEventListener("click", () => {
      hideSubMenu();
    })
    menuTrigger.addEventListener("click", () => {
      toggleMenu();
    })
    closeMenu.addEventListener("click", () => {
      toggleMenu();
    })
    let menuOverlay: any = document.querySelector(".menu-overlay")
    menuOverlay.addEventListener("click", () => {
      toggleMenu();
    })
    function toggleMenu() {
      menu.classList.toggle("active");
      menuOverlay.classList.toggle("active");
    }
    function showSubMenu(hasChildren:any) {
      subMenu = hasChildren.querySelector(".sub-menu");
      subMenu.classList.add("active");
      subMenu.style.animation = "slideLeft 0.5s ease forwards";
      const menuTitle = hasChildren.querySelector("i").parentNode.childNodes[0].textContent;
      menu.querySelector(".current-menu-title").innerHTML = menuTitle;
      menu.querySelector(".mobile-menu-head").classList.add("active");
    }

    function hideSubMenu() {
      subMenu.style.animation = "slideRight 0.5s ease forwards";
      setTimeout(() => {
        subMenu.classList.remove("active");
      }, 300);
      menu.querySelector(".current-menu-title").innerHTML = "";
      menu.querySelector(".mobile-menu-head").classList.remove("active");
    }

    window.onresize = function () {
      // if (this.innerWidth > 991) {
      //   if (menu.classList.contains("active")) {
      //     toggleMenu();
      //   }

      // }
    }


  }

  openMocks(){
    this.changeNav.emit('mocks')
  }

  ngAfterViewInit(){
  }

}
